module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_3000_5000.7fd6b0fb.png";